module.exports = __webpack_public_path__ + "img/a1-s32.0e4f55db.jpg";